export default __webpack_public_path__ + "static/media/hidraulic12.b00f1786.jpg";